import { LoadingText } from "./LoadingText";
export default LoadingText;
export * from "./LoadingText";
